import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronRightDouble16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M9.06072 8L3.53039 2.46967L2.46973 3.53033L6.9394 8L2.46973 12.4697L3.53039 13.5303L9.06072 8Z'
      fill='currentColor'
    />
    <path
      d='M14.0607 8L8.53039 2.46967L7.46973 3.53033L11.9394 8L7.46973 12.4697L8.53039 13.5303L14.0607 8Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronRightDouble16.displayName = 'ChevronRightDouble16';
export default ChevronRightDouble16;
